module.exports = __webpack_public_path__ + "media/images/already-read-label@2x-ca63fe66a1ce84d1efc336f5ec012f25.png";